import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '../../app/store';

const REBRANDING_STORAGE_KEY = 'se-monitor-rebranding';
const WELCOME_MODAL_VERSION = '3.0.0';

export interface RebrandingState {
  modalSeenInVersion: string | null;
}

const getInitialState = (): RebrandingState => {
  try {
    const stored = localStorage.getItem(REBRANDING_STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch {
    // Ignore localStorage errors
  }
  return { modalSeenInVersion: null };
};

const rebrandingSlice = createSlice({
  name: 'rebranding',
  initialState: getInitialState(),
  reducers: {
    markWelcomeModalSeen: (state) => {
      state.modalSeenInVersion = WELCOME_MODAL_VERSION;
      try {
        localStorage.setItem(REBRANDING_STORAGE_KEY, JSON.stringify(state));
      } catch {
        // Ignore localStorage errors
      }
    },
    resetRebrandingState: () => getInitialState(),
  },
});

export const { markWelcomeModalSeen, resetRebrandingState } = rebrandingSlice.actions;

export const selectHasSeenWelcomeModal = (state: RootState) =>
  state.rebranding.modalSeenInVersion === WELCOME_MODAL_VERSION;

export const rebrandingReducer = rebrandingSlice.reducer;
